import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import './components/mobile/mobileShell.css';
import './components/mobile/mobileGames.css';
import './components/keno/mobileLiveStats.css';
import './components/originals/desktopFrame.css';
import './components/originals/desktopBoards.css';
import './components/blackjack/desktopCards.css';
import './components/originals/sharedControls.css';
import './components/keno/desktopLiveStats.css';
import './components/fairness/fairnessTheme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
